import Icon from './Icon';

const StarFilled = (props) => (
  <Icon
    {...props}
    path="M72.367 32.5c-0.296-0.892-1.055-1.552-1.986-1.698l-0.014-0.002-19.433-2.833-8.7-17.6c-0.462-0.765-1.289-1.269-2.233-1.269s-1.771 0.504-2.227 1.257l-0.007 0.012-8.7 17.6-19.433 2.833c-1.211 0.188-2.126 1.223-2.126 2.472 0 0.704 0.291 1.34 0.759 1.794l0.001 0.001 14.033 13.7-3.333 19.333c-0.023 0.127-0.036 0.274-0.036 0.423 0 0.836 0.405 1.577 1.029 2.038l0.007 0.005c0.374 0.235 0.829 0.375 1.317 0.375s0.942-0.14 1.327-0.381l-0.010 0.006 17.4-8.967 17.367 9.133c0.337 0.188 0.739 0.299 1.166 0.3h0c0.001 0 0.003 0 0.005 0 1.381 0 2.5-1.119 2.5-2.5 0-0.153-0.014-0.303-0.040-0.449l0.002 0.015-3.333-19.333 14.033-13.7c0.485-0.452 0.787-1.094 0.787-1.806 0-0.272-0.044-0.533-0.125-0.778l0.005 0.017z"
  />
);

export default StarFilled;
